import React from 'react';
import Text from '../common/form/Text';
import { Link } from 'react-router-dom';


export default function Card({
    classes: {
        card,
        media,
        content
    },
    mediaExists,
    contentHeader: {
        headerId,
        headerClasses,
        headerText,
        headerDisplay,
        headerTextReplacements
    },
    contentText:{
        textId,
        textClasses,
        text,
        display,
        textReplacements,
        isReplacementALink,
        contentRedirects,
        linkText
    },
    actions: {
        cardRedirect,
        isExternal
    },
    id: {
        idValue
    },
    gtm: {
        gtmValue 
    }
}) {
    return (
        <div className={card && card.join(' ')}>
            {
                isExternal ?
                    <a id={idValue} href={cardRedirect} className="gi-card" data-gtm-value={gtmValue}>
                        {mediaExists &&
                        <div className={`gi-card__media ${media && media.join(' ')}`}> </div>
                        }
                        <div className={`gi-card__content__wrapper ${content && content.join(' ')}`}>
                            <div className="gi-card__content">
                                <div className="gi-card__content__heading">
                                    <Text { ...{ id: headerId, classes: headerClasses, text: headerText, display: headerDisplay, textReplacements: headerTextReplacements  } } />
                                </div>
                                <div className="gi-card__content__body">
                                    <Text { ...{ id: textId, classes: textClasses, text, display, textReplacements, isReplacementALink, path: contentRedirects, linkText } } />
                                </div>
                            </div>
                        </div>
                    </a>
                    : <Link id={idValue} to={cardRedirect} className="gi-card">
                        {mediaExists &&
                        <div className={`gi-card__media ${media && media.join(' ')}`}> </div>
                        }
                        <div className="gi-card__content__wrapper">
                            <div className="gi-card__content">
                                <div className="gi-card__content__heading">
                                    <Text { ...{ id: headerId, classes: headerClasses, text: headerText, display: headerDisplay, textReplacements: headerTextReplacements  } } />
                                </div>
                                <div className="gi-card__content__body">
                                    <Text { ...{ id: textId, classes: textClasses, text, display, textReplacements, isReplacementALink, path: contentRedirects, linkText } } />
                                </div>
                            </div>
                        </div>
                    </Link>
            }
        </div>
    );
}

Card.defaultProps = {
    gtm: {
        gtmValue: null
    }
};

//card: desktop:grid-col-12 tablet:grid-col-12 mobile-lg:grid-col-12 grid-col-12
//media: gi-card__media gi-card__media--doctor
